import { z } from 'zod';

export const productCapabilitiesSchema = z.strictObject({
  schemaVersion: z.literal(1),
  classification: z.literal('server-release-gates-only'),
  preferredExecution: z.literal('vault'),
  terminal: z.strictObject({
    publicEnabled: z.boolean(),
    directWalletEnabled: z.boolean(),
  }),
  launchpad: z.strictObject({
    publicEnabled: z.boolean(),
    directWalletEnabled: z.boolean(),
  }),
  automaticOrders: z.strictObject({
    admissionEnabled: z.boolean(),
    executionMode: z.literal('vault-only'),
  }),
  directWallet: z.strictObject({
    requiresPerActionApproval: z.literal(true),
    browserClosedAutomation: z.literal(false),
  }),
  analytics: z.strictObject({
    ingestEnabled: z.boolean(),
    requiresConsent: z.literal(true),
    crossSiteTracking: z.literal(false),
  }),
});

export type ProductCapabilities = z.infer<typeof productCapabilitiesSchema>;
